import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractFullMessages } from '@/utils/extract'
import { AGENCY_QUOTATION_INIT_LOADING, AGENCY_QUOTATION_INIT_SUCCESS, AGENCY_QUOTATION_INIT_FAIL, QUOTE_FIRE_PARAM, QUOTE_FIRE_GENERAL, QUOTE_FIRE_PARAM_PLAN_LOADING, QUOTE_FIRE_PARAM_PLAN_SUCCESS, QUOTE_FIRE_PARAM_PLAN_FAIL, QUOTE_FIRE_ADJ_CANCEL, QUOTE_FIRE_RECALCULATE_LOADING, QUOTE_FIRE_RECALCULATE_SUCCESS, QUOTE_FIRE_RECALCULATE_FAIL } from '@/store/types'

export const fire = {
  async fireQuoteInit({ commit, state }) {
    const expand = {
      intermediary: state.quotation.commonForm.intermediary
    }
    const apiUrl = expandURI(state.quotationSettings.menu.fire, expand)
    if (apiUrl) {
      commit(AGENCY_QUOTATION_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(AGENCY_QUOTATION_INIT_SUCCESS, commitResult)
        if (commitResult.hasContent) {
          commit(QUOTE_FIRE_PARAM, commitResult.data)
        }
      } catch (error) {
        commit(AGENCY_QUOTATION_INIT_FAIL)
      }
    } else {
      commit(AGENCY_QUOTATION_INIT_FAIL, ['Invalid API URL'])
    }
  },
  async fireQuoteGeneral({ commit, state }, data) {
    // Before committing the data, we will check what is affected by the change of fireQuoteGeneral fields
    const commonForm = state.quotation.commonForm

    // Check if there is a change of scheme
    if (!commonForm.scheme || commonForm.scheme !== data.scheme) {
      // Need clear out plan here
      commit(QUOTE_FIRE_ADJ_CANCEL)
    }

    // Check if there is a change of disc/comm fields (promotions)
    if (!commonForm.promotion || commonForm.promotion !== data.promotion) {
      commit(QUOTE_FIRE_RECALCULATE_LOADING)
    }
    commit(QUOTE_FIRE_GENERAL, data)
  },
  async fireQuotePlans({ commit, state }) {
    const apiUrl = state.quotation.menu.firePlans
    if (apiUrl) {
      try {
        commit(QUOTE_FIRE_PARAM_PLAN_LOADING)

        const { commonForm } = state.quotation
        const calcForm = {
          appID: commonForm.appID,
          intermediary: commonForm.intermediary,
          product: commonForm.product,
          scheme: commonForm.scheme,
          duration: commonForm.duration,
          acceptDate: commonForm.acceptDate,
          startDate: commonForm.startDate,
          endDate: commonForm.endDate,
          optCvr: commonForm.optCvr,
          campaign: commonForm.campaign,
          promotion: commonForm.promotion
        }
        const result = await http.post(apiUrl, calcForm)
        const { data } = result
        commit(QUOTE_FIRE_PARAM_PLAN_SUCCESS, data)
      } catch (error) {
        commit(QUOTE_FIRE_PARAM_PLAN_FAIL, extractFullMessages(error))
      }
    } else {
      commit(QUOTE_FIRE_PARAM_PLAN_FAIL)
    }
  },
  async fireQuoteRecalculate({ commit, state }) {
    const apiURI = state.quotation.menu.recalculate
    if (apiURI) {
      commit(QUOTE_FIRE_RECALCULATE_LOADING)
      try {
        const { commonForm, fireForm } = state.quotation

        const calcForm = {
          appID: commonForm.appID,
          intermediary: commonForm.intermediary,
          product: commonForm.product,
          scheme: commonForm.scheme,
          duration: commonForm.duration,
          acceptDate: commonForm.acceptDate,
          startDate: commonForm.startDate,
          endDate: commonForm.endDate,
          optCvr: commonForm.optCvr,
          planNo: fireForm.planNo,
          campaign: commonForm.campaign,
          promotion: commonForm.promotion,
          adjDiscount: commonForm.adjDiscount
        }

        const result = await http.post(apiURI, calcForm)
        if (result.data) {
          const { data } = result
          commit(QUOTE_FIRE_RECALCULATE_SUCCESS, data)
        }
      } catch (err) {
        commit(QUOTE_FIRE_RECALCULATE_FAIL, extractFullMessages(err))
      }
    } else {
      commit(QUOTE_FIRE_RECALCULATE_FAIL, ['Invalid API URL'])
    }
  }
}
